// Categorias de questões com cores, tempos e ícones para simulado
export const CATEGORIES = {
  INFORMATICA: {
    id: 'INFORMATICA',
    label: 'Informática',
    color: '#3B82F6', // Azul
    time: 120, // 2 minutos em segundos
    order: 1,
    icon: '💻',
  },
  CONHECIMENTOS_BANCARIOS: {
    id: 'CONHECIMENTOS_BANCARIOS',
    label: 'Conhecimentos Bancários',
    color: '#10B981', // Verde
    time: 120,
    order: 2,
    icon: '🏦',
  },
  INGLES: {
    id: 'INGLES',
    label: 'Inglês',
    color: '#8B5CF6', // Roxo
    time: 120,
    order: 3,
    icon: '🇺🇸',
  },
  MATEMATICA: {
    id: 'MATEMATICA',
    label: 'Matemática',
    color: '#F59E0B', // Amarelo
    time: 480, // 8 minutos
    order: 4,
    icon: '🔢',
  },
  ATENDIMENTO: {
    id: 'ATENDIMENTO',
    label: 'Atendimento',
    color: '#EC4899', // Rosa
    time: 120,
    order: 5,
    icon: '🤝',
  },
  ATUALIDADES: {
    id: 'ATUALIDADES',
    label: 'Atualidades',
    color: '#6366F1', // Indigo
    time: 120,
    order: 6,
    icon: '📰',
  },
  MATEMATICA_FINANCEIRA: {
    id: 'MATEMATICA_FINANCEIRA',
    label: 'Mat. Financeira',
    color: '#EF4444', // Vermelho
    time: 480, // 8 minutos
    order: 7,
    icon: '📊',
  },
  PORTUGUES: {
    id: 'PORTUGUES',
    label: 'Português',
    color: '#14B8A6', // Teal
    time: 120,
    order: 8,
    icon: '📝',
  },
  GERAL: {
    id: 'GERAL',
    label: 'Geral',
    color: '#64748B', // Slate
    time: 120,
    order: 9,
    icon: '📚',
  },
};

// Array ordenado para uso em listas
export const CATEGORIES_LIST = Object.values(CATEGORIES).sort((a, b) => a.order - b.order);

// Ordem das categorias para o simulado cronometrado
export const SIMULADO_ORDER = [
  'GERAL',
  'CONHECIMENTOS_BANCARIOS',
  'PORTUGUES',
  'INFORMATICA',
  'MATEMATICA',
  'ATUALIDADES',
  'ATENDIMENTO',
  'MATEMATICA_FINANCEIRA',
  'INGLES',
];

// Constantes do sistema de repetição espaçada
export const REPETITION_CONFIG = {
  FIRST_REPEAT_INTERVAL: 5, // 1ª repetição: após 5 questões
  SUBSEQUENT_REPEAT_INTERVAL: 3, // 2ª+ repetições: após 3 questões
  CORRECT_COUNT_TO_REMOVE: 50, // Acertos necessários para remover do modo repetição
};

// Dias da semana para o sistema de revisões
export const WEEKDAYS = [
  { id: 'MONDAY', label: 'Segunda-feira', shortLabel: 'SEG', icon: '📅', color: '#3B82F6' },
  { id: 'TUESDAY', label: 'Terça-feira', shortLabel: 'TER', icon: '📅', color: '#10B981' },
  { id: 'WEDNESDAY', label: 'Quarta-feira', shortLabel: 'QUA', icon: '📅', color: '#8B5CF6' },
  { id: 'THURSDAY', label: 'Quinta-feira', shortLabel: 'QUI', icon: '📅', color: '#F59E0B' },
  { id: 'FRIDAY', label: 'Sexta-feira', shortLabel: 'SEX', icon: '📅', color: '#EC4899' },
  { id: 'SATURDAY', label: 'Sábado', shortLabel: 'SÁB', icon: '📅', color: '#6366F1' },
  { id: 'SUNDAY', label: 'Domingo', shortLabel: 'DOM', icon: '📅', color: '#EF4444' },
];

// Configuração padrão de categorias por dia da semana
export const DEFAULT_REVIEW_SCHEDULE = {
  MONDAY: ['MATEMATICA', 'MATEMATICA_FINANCEIRA'],
  TUESDAY: ['PORTUGUES', 'INGLES'],
  WEDNESDAY: ['INFORMATICA', 'ATUALIDADES'],
  THURSDAY: ['CONHECIMENTOS_BANCARIOS', 'ATENDIMENTO'],
  FRIDAY: ['MATEMATICA', 'PORTUGUES'],
  SATURDAY: ['INFORMATICA', 'CONHECIMENTOS_BANCARIOS', 'ATUALIDADES'],
  SUNDAY: ['GERAL'],
};

// Storage keys
export const STORAGE_KEYS = {
  QUESTIONS: '@questoes_app/questions',
  HISTORY: '@questoes_app/history',
  REVIEW_SCHEDULE: '@questoes_app/review_schedule',
  ANSWER_LOG: '@questoes_app/answer_log',
  SPACED_QUESTIONS: '@questoes_app/spaced_questions',
  SPACED_LAST_RESET: '@questoes_app/spaced_last_reset',
  SHORT_TERM_MEMORY: '@questoes_app/short_term_memory',
};

// Intervalos de repetição espaçada (em dias de inatividade após cada revisão)
// Primeira resolução: 3 dias de inatividade
// 2ª revisão: 5 dias de inatividade
// 3ª revisão: 8 dias de inatividade
// 4ª+ revisões: 12 dias de inatividade (permanente)
export const SPACED_INTERVALS = [3, 5, 8, 12];

// Nº de revisões (em dias distintos) p/ uma questão espaçada ser "Dominada" (Longo Prazo)
export const LONG_TERM_REVIEW_COUNT = 4;

// ==================== MEMÓRIA DE CURTO PRAZO ====================
// Sistema de captura automática de questões erradas
export const SHORT_TERM_MEMORY_CONFIG = {
  CONSECUTIVE_CORRECT_TO_PROMOTE: 5,  // Acertos para promoção (mais de 4 = 5)
  MAX_QUESTIONS_DISPLAY: 50,          // Máximo de questões exibidas
  DAYS_TO_EXPIRE: 30,                 // Dias para expirar se não praticada
};

// Intervalos de revisão espaçada para memória de curto prazo (em dias)
// Mesmo padrão da Repetição Espaçada
export const SHORT_TERM_INTERVALS = [3, 5, 8, 12];

// Retorna o intervalo para a próxima revisão baseado no número de acertos
export const getShortTermInterval = (correctCount) => {
  const index = Math.min(correctCount, SHORT_TERM_INTERVALS.length - 1);
  return SHORT_TERM_INTERVALS[index];
};

// Cores do tema Memória de Curto Prazo
export const SHORT_TERM_COLORS = {
  primary: '#FF6B6B',        // Vermelho coral (urgência)
  primaryLight: '#FF8E8E',
  primaryDark: '#E85555',
  success: '#51CF66',        // Verde (acerto)
  warning: '#FFD93D',        // Amarelo (atenção)
  error: '#FF4757',          // Vermelho intenso (erro)
  gradientStart: '#FF6B6B',
  gradientEnd: '#FF8E53',
};

// Cores do tema Memória de Médio Prazo
export const MEDIUM_TERM_COLORS = {
  primary: '#5B8FF9',        // Azul (consolidação)
  primaryLight: '#7AA6FF',
  primaryDark: '#4A7AE5',
  success: '#51CF66',
  warning: '#FFD93D',
  error: '#FF4757',
  gradientStart: '#5B8FF9',
  gradientEnd: '#667eea',
};

// Cores do tema Memória de Longo Prazo
export const LONG_TERM_COLORS = {
  primary: '#51CF66',        // Verde (dominado)
  primaryLight: '#69E07A',
  primaryDark: '#40C057',
  success: '#51CF66',
  warning: '#FFD93D',
  error: '#FF4757',
  gradientStart: '#51CF66',
  gradientEnd: '#40C057',
};

